import React, { useEffect, useRef, useState } from "react";
import "./main.css";
import SearchBar from "../components/SearchBar/SearchBar";
import { useSelector } from "react-redux";
import AppsList from "../components/AppsList/AppsList";
import Catalog from "../components/AppsList/Catalog/Catalog";
import Outages from "../components/Outages/Outages";
import Queries from "../components/Queries/Outages";
import ErrorPopup from "../components/Popups/ErrorPopup/ErrorPopup";
import CustomTabs from "../components/CustomTabs/CustomTabs";
import { getRecentSearchUrl } from "../utils/constants";
import { updateRecentSearches } from "../../../../utils/redux-store/slices/searchSlice";
import { useDispatch } from "react-redux";
import { useTheme } from "@mui/material";
import { tokens } from "../../../../theme";

interface MainProps {
  redirectUrl?: string;
}

const Main: React.FC<MainProps> = ({ redirectUrl }) => {
  const userProfile = useSelector((store: any) => store.login.loginDetails);
  const [activeTab, setActiveTab] = useState<string>("Apps"); // Default is none active
  const [indicatorStyle, setIndicatorStyle] = useState<React.CSSProperties>({}); // Style for the indicator
  const buttonsRef = useRef<(HTMLDivElement | null)[]>([]); // Store refs to buttons
  const [tokenExpired, setTokenExpired] = useState(false);
  const dispatch = useDispatch();

  const theme = useTheme(); // Access the current theme
  const colors = tokens(theme.palette.mode);

  useEffect(() => {
    getRecentSearches();
  }, [])

  const getRecentSearches = async () => {
    try {
      const options = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      };
      const url = getRecentSearchUrl + "?userId=" + userProfile.email;
      const result = await (await fetch(url, options)).json();
      if (result) {
        dispatch(updateRecentSearches({ value: result }));
      }
    } catch (err) {
      console.log('ERROR :::', err);
      dispatch(updateRecentSearches({ value: [] }));
    }
  }

  const handleButtonClick = (tabName: string, index: number) => {
    setActiveTab(tabName); // Update the active tab
    const button = buttonsRef.current[index]; // Get the clicked button element
    console.log(buttonsRef.current[index]);

    if (button) {
      // Set the width and left position of the indicator
      setIndicatorStyle({
        width: `${button.offsetWidth}px`,
        left: `${button.offsetLeft}px`,
      });
    }
  };

  useEffect(() => {
    // Initially set the indicator to the first button's position (if necessary)
    if (buttonsRef.current[0]) {
      setIndicatorStyle({
        width: `${buttonsRef.current[0]!.offsetWidth}px`,
        left: `${buttonsRef.current[0]!.offsetLeft}px`,
      });
    }
  }, []);

  if (tokenExpired) {
    return <ErrorPopup error_msg="Token Expired" />;
  }

  const tabData = [
    {
      name: "Apps",
      content: (
        <div>
          <div className="display_apps">
            <AppsList redirectUrl={redirectUrl} />
          </div>
          <div className="catalog-content-display">
            <Catalog mode={theme.palette.mode} />
          </div>
        </div>
      ),
    },
    {
      name: "List of Outages",
      content: (
        <div className="catalog-content-display">
          <Outages mode={theme.palette.mode} />
        </div>
      ),
    },
    {
      name: "Top 10 Queries",
      content: (
        <div className="catalog-content-display">
          <Queries />
        </div>
      ),
    },
  ];

  return (
    <div>
      <div className="main-display">
        <div className="title-main">
          <div><img src="/ui/static/img/logos/CDD_logo.png" alt="Avatar" style={{
            width: '90px',
            height: '90px',
            borderRadius: '50%',
            display: 'block',
            margin: 'auto',
            padding: '5px',
          }}/></div>
          <h1 className="heading">CVA APP</h1>
          <p className="welcome-msg">
            Hi {userProfile["given_name"]}, How can I help you?
          </p>
        </div>
        <div className="main-searchbar">
          <SearchBar />
        </div>
      </div>

      <CustomTabs data={tabData} />
    </div>
  );
};

export default Main;
